<template>
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12" v-for="(item, index) in items" :key="index">
            <topper-card :data="item"></topper-card>
        </div>
    </div>
</template>

<script>
import DateFilter from '@/components/DateFilter.vue';
import TeamFilter from '@/components/TeamFilter.vue';
import Avatar from '@/components/Avatar.vue';
import { mapActions, mapGetters } from 'vuex';
import TopperCard from "./TopperCard";

export default {
    components: {
        TopperCard,
        Avatar,
        DateFilter,
        TeamFilter
    },
    props: { user: Array, dates: Object, branchesId: Array },
    data() {
        return {
            team: {},
            customers: {},
            items: [],
            params: {
                query: {},
            },
        }
    },
    watch: {
        dates(dates) {
            this.fetchReport();
        },

        branchesId(newValue) {
            this.fetchReport();
        }

    },
    computed: {
        ...mapGetters('categories', { getCategory: 'get' }),
    },
    created() {
        this.fetchReport();
    },
    methods: {
        ...mapActions('toppers', ['find']),

        fetchReport() {
            let query = {};
            if (this.dates.start) {
                query.date = {
                    $gte: this.dates.start,
                    $lte: this.dates.end
                }
            }

            if (this.branchesId.length > 0)
                query.branchesId = this.branchesId;

            this.items = [];
            this.find({ query }).then(data => {
                data = data[0];
                let team = data.team;
                let customers = data.customers;
                let products = data.products;
                let services = data.services;
                this.items = [
                    {
                        label: 'Most selling product',
                        text: products.mProfit.label,
                        value: products.mProfit.amount,
                        money: true
                    },
                    {
                        label: 'Least selling product',
                        text: products.lProfit.label,
                        value: products.lProfit.amount,
                        money: true
                    },
                    {
                        label: 'Most used product',
                        text: products.mCount.label,
                        value: products.mCount.amount,
                        units: true
                    },
                    {
                        label: 'Least used product',
                        text: products.lCount.label,
                        value: products.lCount.amount,
                        units: true
                    },
                    {
                        label: 'Most selling service',
                        text: services.mProfit.label,
                        value: services.mProfit.amount,
                        money: true
                    },
                    {
                        label: 'Least selling service',
                        text: services.lProfit.label,
                        value: services.lProfit.amount,
                        money: true
                    },
                    {
                        label: 'Most used service',
                        text: services.mCount.label,
                        value: services.mCount.amount,
                        units: true
                    },
                    {
                        label: 'Least used service',
                        text: services.lCount.label,
                        value: services.lCount.amount,
                        units: true
                    }
                ]

                if (this.$loadModule('billing')){
                    this.items.unshift(
                        {
                            label: 'Most valuable patient',
                            text: `${customers.mProfit.first_name || ''} ${customers.mProfit.last_name || ''}`,
                            value: customers.mProfit.amount,
                            money: true
                        },
                        {
                            label: 'Least valuable patient',
                            text: `${customers.lProfit.first_name || ''} ${customers.lProfit.last_name || ''}`,
                            value: customers.lProfit.amount,
                            money: true
                        },
                        {
                            label: 'Most debt patient',
                            text: `${customers.mDebt.first_name || ''} ${customers.mDebt.last_name || ''}`,
                            value: customers.mDebt.balance,
                            money: true
                        },
                        {
                            label: 'Most prepaid patient',
                            text: `${customers.mPrepaid.first_name || ''} ${customers.mPrepaid.last_name || ''}`,
                            value: customers.mPrepaid.balance,
                            money: true
                        },
                    )
                }

                if (this.$hasPermission('toppers', ['seeAll'])) {
                    this.items.push({
                        label: 'Most valuable team member',
                        text: `${team.mProfit.firstName || ''} ${team.mProfit.lastName || ''}`,
                        value: team.mProfit.amount,
                        money: true
                    },
                        {
                            label: 'Least valuable team member',
                            text: `${team.lProfit.firstName || ''} ${team.lProfit.lastName || ''}`,
                            value: team.lProfit.amount,
                            money: true
                        })
                }
            });
        },


    }
}
</script>

<style>

</style>
